<section>
    <span c-activity-log-blurb activity="activity"></span>{{message}}
    <span class="tag" ng-repeat="tagName in tagNames track by $index">
       <span ng-bind-html="tagAsHtml(localize(tagName))"></span>{{$last ? '' : ','}}
    </span>
    <!--<div c-activity-log-message activity="activity"></div>-->
</section>